import { isChildOfTag, isTag } from 'anodum';

const preventLinkRedirection = (event) => {
  if (isTag(event.target, 'a') || isChildOfTag(event.target, 'a')) {
    event.preventDefault();
  }
};

export default preventLinkRedirection;
